import { IApplicationState } from '../../../../../types/types';
import { TCardRestGetSectionsRequest } from '../../card/api/helper/cardRestGetSections';
import { ICard } from '../../../../../store/model/card/types';
import {
    getCardChecklistItemsNumber
} from '../../../../../store/model/checklists/checklists/selectors/getCardChecklistItemsNumber';

export const getChecklistsCardsRequest = (
    state: IApplicationState,
    cards: ICard[]
): TCardRestGetSectionsRequest[] => {
    const cardRequest: TCardRestGetSectionsRequest[] = [];
    cards.forEach(card => {
        if (card.checklistStats.totalCount > 0 && !getCardChecklistItemsNumber(state, card.id)) {
            cardRequest.push({
                cardId: card.id,
                sections: ['checklists']
            });
        }
    });
    return cardRequest;
}
